









import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class PValue extends Vue {
    @Prop() type: string | undefined;
    @Prop() icon: string | undefined;
    @Prop() iconColor: string | undefined;
    @Prop() iconTooltip: string | undefined;
}
